import getCurrentReduxSelector from '../../../../redux/selectors/get-current'
import WORKOUTS_PATH from '../../constants/path'

const getCurrentWorkoutSelect = getCurrentReduxSelector(
  WORKOUTS_PATH.DATA,
  WORKOUTS_PATH.CURRENT
)

export default getCurrentWorkoutSelect
